import type { ToastServiceMethods } from 'primevue'
import emailAdapter from '@/api/adapter/emailAdapter'

interface AxiosContext {
  toast: () => ToastServiceMethods
}
interface AxiosRequestWrapper {
  value: AxiosContext
}

const axiosContext: AxiosRequestWrapper = {} as AxiosRequestWrapper

const api = emailAdapter(axiosContext)

export default api

export const axiosInstall = (context: AxiosContext) => (axiosContext.value = context)
